import React from 'react';
import './Impressum.css';

const Impressum: React.FC = () => {
  return (
    <div className="impressum">
      <div className="container">
        <section className="impressum-header">
          <h1>Impresszum</h1>
          <p>Utolsó frissítés: 2024. február 22.</p>
        </section>

        <section className="impressum-content">
          <div className="impressum-section">
            <h2>Szolgáltató</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="label">Név:</span>
                <span className="value">Lakics Márk</span>
              </div>
              <div className="info-item">
                <span className="label">Vállalkozás formája:</span>
                <span className="value">Egyéni vállalkozó</span>
              </div>
              <div className="info-item">
                <span className="label">Székhely:</span>
                <span className="value">9073 Bőny, Szabadság út 49.</span>
              </div>
              <div className="info-item">
                <span className="label">Adószám:</span>
                <span className="value">67003701-1-28</span>
              </div>
              
            </div>
          </div>

          <div className="impressum-section">
            <h2>Elérhetőségek</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="label">Telefonszám:</span>
                <span className="value">0036309869878</span>
              </div>
              <div className="info-item">
                <span className="label">Email:</span>
                <span className="value">info@lakicsfesto.com</span>
              </div>
              <div className="info-item">
                <span className="label">Weboldal:</span>
                <span className="value">www.gyorszobafesto.hu</span>
              </div>
            </div>
          </div>

          <div className="impressum-section">
            <h2>Szolgáltatási terület</h2>
            <p>
              Főként Győr és környékén vállalok szobafestési munkálatokat, beleértve:
            </p>
            <ul>
              <li>Böny</li>
              <li>Győr</li>
              <li>Győrújfalu</li>
              <li>Nagybajcs</li>
              <li>Abda</li>
              <li>Érsekkál</li>
              <li>és a környező települések</li>
            </ul>
          </div>

          <div className="impressum-section">
            <h2>Tevékenység</h2>
            <p>
              Főtevékenység: Szobafestés, mázolás, tapétázás
            </p>
          </div>

          <div className="impressum-section">
            <h2>Fizetési lehetőségek</h2>
            <ul>
              <li>Készpénz</li>
              <li>Banki átutalás</li>
            </ul>
          </div>

          <div className="impressum-section">
            <h2>Garancia</h2>
            <p>
              Munkáimra a jogszabályok szerinti garanciát vállalom. A garancia 
              időtartama és feltételei a szerződésben kerülnek rögzítésre.
            </p>
          </div>

          <div className="impressum-section">
            <h2>Tárhelyszolgáltató</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="label">Név:</span>
                <span className="value">TM Infotech Kft.</span>
              </div>
              <div className="info-item">
                <span className="label">Cím:</span>
                <span className="value">9325 Sopronnémeti, Hunyadi utca 3/a</span>
              </div>
              <div className="info-item">
                <span className="label">Email:</span>
                <span className="value">info@tm-it.hu</span>
              </div>
              <div className="info-item">
                <span className="label">Web:</span>
                <span className="value">https://tm-it.hu</span>
              </div>
            </div>
          </div>

          <div className="impressum-section">
            <h2>Jogi nyilatkozat</h2>
            <p>
              A weboldalon található információk tájékoztató jellegűek, nem minősülnek 
              szerződéses ajánlatnak. Az árak és feltételek változhatnak, minden esetben 
              a megkötött szerződésben rögzített adatok érvényesek.
            </p>
            <p>
              A weboldal tartalma szerzői jogvédelem alatt áll. A tartalmak 
              másolása, terjesztése csak a szerző írásos engedélyével lehetséges.
            </p>
          </div>

          <div className="impressum-section">
            <h2>Alternatív vitarendezés</h2>
            <p>
              Amennyiben a fogyasztó és a vállalkozás közötti vitát nem sikerül 
              békés úton rendezni, a fogyasztó a következő lehetőségekkel élhet:
            </p>
            <ul>
              <li>Békéltető testületi eljárás kezdeményezése</li>
              <li>Fogyasztói jogok képviselőjének segítsége</li>
              <li>Bírósági úton való érvényesítés</li>
            </ul>
            <p>
              A Győr-Moson-Sopron megyei Békéltető Testület elérhetőségei:<br />
              Cím: 9021 Győr, Szent István út 10/a.<br />
              Telefon: (96) 504-742<br />
              Email: bekelteto@gyirmosonmegye.hu
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Impressum;
